import styled, { createGlobalStyle, css } from 'styled-components';
import GridContainer from '@stelecom/ui-react/components/layouts/gridContainer';
import { COLORS, FONTS } from '@stelecom/ui-react/assets/js/constants';
import CitySelection from '@stelecom/ui-react/components/popups/citySelection';
import styledButton from '@stelecom/ui-react/components/buttons/styledButton';

export const breakpoints = {
  desktop: '1599px',
  sDesktop: '1365px',
  tablet: '1023px',
  mobile: '767px',
  sMobile: '350px',
};

const colorsConstants = {
  darkGrey: '#505050',
};

export const Wrapper = styled.div<{
  isAuth: boolean;
  isFixed: boolean;
  withPlank: boolean;
  isVisibility: boolean;
}>`
  display: block;
  position: fixed;
  width: 100%;

  top: 0;
  left: 0;
  background: ${COLORS.white};
  z-index: 11;
  padding: 0 90px;

  @media (max-width: ${breakpoints.sDesktop}) {
    position: fixed;
    top: 0;
    padding: 0 20px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 0;
  }
`;

export const HeaderWrapper = styled(GridContainer)`
  display: block;
  min-width: 288px;
  position: relative;

  @media (max-width: 1599px) {
    width: 100%;
    max-width: 1360px;
    padding: 0;
  }

  @media (max-width: ${breakpoints.mobile}) {
    padding: 0;
  }
`;

export const TopWrapper = styled.div<{
  isFixed: boolean;
  isVisibility: boolean;
}>`
  display: ${(p) => (p.isVisibility ? 'flex' : 'none')};
  height: 56px;
  ${FONTS.XXS}
  color: ${COLORS.darkGrey};
  a {
    color: ${COLORS.darkGrey};
    transition: 0.3s color ease;

    &:hover {
      color: ${COLORS.PINK_BRIGHT};
    }

    @media (max-width: ${breakpoints.mobile}) {
      color: ${COLORS.black};
    }
  }

  @media (max-width: ${breakpoints.mobile}) {
    display: flex;
  }

  &:after {
    position: absolute;
    width: calc(100% - 64px);
    height: 0.5px;
    top: 38px;
    left: 32px;

    @media (max-width: ${breakpoints.desktop}) {
      width: 100%;
      left: 0;
    }

    @media (max-width: ${breakpoints.mobile}) {
      width: calc(100% - 32px);
      left: 16px;
    }
  }
`;

export const MainWrapper = styled.div`
  position: relative;
  height: 73px;
  align-items: center;
  flex-wrap: nowrap;
  background-color: ${COLORS.lightBlue};
  border-radius: 8px;

  @media (max-width: ${breakpoints.sDesktop}) {
    padding-left: 0;
    align-items: center;
    justify-content: space-between;
  }
`;

export const DesktopBlock = styled.div`
  flex: 0 1 auto;
  display: flex;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  z-index: 1;

  @media (max-width: ${breakpoints.sDesktop}) {
    justify-content: space-between;
  }
  @media (max-width: ${breakpoints.mobile}) {
    //width: calc(100% - 72px);
    //padding-left: 36px;
    //padding-right: 36px;
  } ;
`;

export const TextMenu = styled.div`
  ${FONTS.H2};
  margin-left: 12px;

  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 18px;
  }
`;

export const CrutchWindow = styled.div`
display: none;
`;

export const DropDownContanerTop = styled.div`
  justify-content: space-between;
  height: fit-content;

  @media (max-width: ${breakpoints.mobile}) {
    width: 280px;
  }
`;

export const DropDownContanerBottom = styled.div`
  height: auto;
  margin-top: -8px;

  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 0;
    overflow: scroll;
    overflow-y: hidden;
    scrollbar-width: thin;

    &::-webkit-scrollbar {
      width: 0;
    }
  }
`;

export const LinkItemDrop = styled.a<{ isDrop: boolean; color?: string }>`
  ${FONTS.Medium};
  ${({ isDrop, color }) =>
    isDrop &&
    css`
      height: 27px;
      background-color: ${COLORS.white};
      border-radius: 14px;
      line-height: 25px;
      text-align: center;
      color: ${color ? color : colorsConstants.darkGrey};
      padding: 0 12px;
    `}
`;

export const TabletBlock = styled.div`
  display: none;

  @media (max-width: ${breakpoints.sDesktop}) {
    display: flex;
    width: 25%;
  }

  @media (max-width: ${breakpoints.mobile}) {
    width: 100%;
  }
`;

export const MobileBlock = styled.div`
  display: none;
  ${FONTS.XXS};

  @media (max-width: ${breakpoints.mobile}) {
    display: flex;
  }

  a:after {
    position: absolute;
    left: -20px;
    top: -1px;
    content: "";
    width: 14px;
    height: 14px;
    background-image: url("${require('~/static/images/menu/auth-new.svg')}");
    background-repeat: no-repeat;
    background-position: center;
  }
`;

export const Logo = styled.div`
  flex: 0;
  display: flex;
  margin-right: 20px;
  margin-left: 24px;

  @media (max-width: ${breakpoints.mobile}) {
    flex: 0 1 auto;
    margin-right: 17px;
  }

  @media (max-width: ${breakpoints.sMobile}) {
    margin-right: 14px;
  }
`;
export const TopMenuWrapper = styled.div``;

export const TopMenuBlock = styled.div<{
  isBottom?: boolean;
  needMobileSt?: boolean;
}>`
  width: ${(p) => (p.isBottom ? '100%' : '300px')};
  justify-content: left;
  ${FONTS.XS}

  ${(p) =>
    p.isBottom &&
    css`
      margin-top: 20px;

      @media (max-width: ${breakpoints.mobile}) {
        margin-top: 10px;
        width: max-content;
      }
    `}
`;

export const TopMenuBlockRight = styled.div`
  flex-direction: column;
  ${FONTS.XS};

  @media (max-width: ${breakpoints.mobile}) {
    flex-direction: row;
    margin-top: 10px;
    ${FONTS.XXS};
  }
`;

export const TopMenuItem = styled.div<{
  isDrop?: boolean;
  isBottom?: boolean;
  isUnderMenuText?: boolean;
}>`
    position: relative;
    margin-right: 20px;
    ${FONTS.Medium};
    align-self: center;
    transition: 0.3s color ease;
    cursor: pointer;

    &:hover {
        color: ${COLORS.PINK_BRIGHT};
        &.element:after {
          background-color: ${COLORS.PINK_BRIGHT};
        }
    }
  
  &.element:after {
    content: "";
    width: 100%;
    height: 1px;
    bottom: 0;
    position: absolute;
    background-color: ${colorsConstants.darkGrey};
  }

    &:hover>div {
        height: auto;
        padding: ${(p) => (p.isDrop ? 0 : '22px 16px 16px')}
        display: flex;
    }

    ${({ isUnderMenuText, isDrop }) =>
      isDrop &&
      css`
        flex-wrap: wrap;
        margin-bottom: 12px;

        @media (max-width: ${breakpoints.mobile}) {
          margin-bottom: 8px;
          ${isUnderMenuText &&
          css`
            padding: 6px;
          `}
        }
      `}

    ${(p) =>
      p.isBottom &&
      css`
        width: fit-content;
        margin-right: 12px;

        @media (max-width: ${breakpoints.mobile}) {
          margin-right: 0;
        }
      `}
`;

export const CollapsedMenu = styled.div`
  z-index: 99;
  height: 0;
  display: none;
  overflow: hidden;
  position: absolute;
  left: 50%;
  top: 65%;
  transform: translate(-50%, 0);
  padding: 0 16px;
  border-radius: 8px;
  transition: padding 0.1s ease;
  box-shadow: 0 8px 16px rgba(52, 55, 61, 0.12);
  white-space: nowrap;

  &:before {
    content: "";
    background: ${COLORS.white};
    border-radius: 8px;
    top: 0;
    height: 100%;
    left: 0;
    right: 0;
    position: absolute;
    z-index: 3;
  }

  a,
  span {
    position: relative;
    z-index: 5;
    display: flex;
    margin-bottom: 20px;
    line-height: 1.2;

    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export const Right = styled.div<{ isAuth?: boolean; isAllItemsView?: boolean }>`
  flex: 1 0 1px;
  display: ${(p) => (p.isAllItemsView ? 'none' : 'flex')};
  justify-content: flex-end;
  align-items: center;
  flex-wrap: nowrap;
  width: 100%;
  height: 100%;
  ${FONTS.XS};

  @media (max-width: ${breakpoints.desktop}) {
    width: ${(p) => (p.isAuth ? '100%' : 'auto')};
  }

  @media (max-width: ${breakpoints.sDesktop}) {
    display: flex;
    width: 100%;
  }

  @media (max-width: ${breakpoints.tablet}) {
    flex: 1 1 1px;
    padding-left: 0;
    margin-left: 16px;
    overflow: hidden;
  }

  @media (max-width: ${breakpoints.sMobile}) {
    margin-left: 14px;
  }
`;

export const BlockForCitySelection = styled.div`
  position: absolute;
  right: 0;
  top: 10px;

  @media (max-width: ${breakpoints.sDesktop}) {
    top: 62px;
  }
`;

export const CitySelectionCustom = styled(CitySelection)`
  position: relative;
  pointer-events: auto;
  z-index: 20;
  top: 0;
`;

export const HeaderPhone = styled.a`
  align-self: center;
  padding: 0 12px;
  color: ${COLORS.darkGrey};
  ${FONTS.Medium};
  line-height: 27px;
  white-space: nowrap;
  background-color: #ffffff;
  border-radius: 14px;
  transition: 0.3s color ease;

  &:hover {
    color: ${COLORS.PINK_BRIGHT};
  }

  @media (max-width: ${breakpoints.mobile}) {
    margin-right: 16px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    margin-left: 0;
    ${FONTS.Medium};
    line-height: 27px;
  }
`;

export const CallbackLink = styled.div`
  align-items: center;
  margin-top: 8px;
  padding: 0 12px;
  ${FONTS.Medium}
  line-height: 27px;
  color: ${COLORS.darkGrey};
  background-color: #ffffff;
  border-radius: 14px;

  &:hover {
    color: ${COLORS.brightBlue};
  }

  @media (max-width: 1279px) and (min-width: 1024px) {
    margin-left: auto;
  }

  @media (max-width: ${breakpoints.mobile}) {
    margin-top: 0;
    ${FONTS.Medium}
  }
`;

export const BurgerIcon = styled.div`
  display: none;

  @media (max-width: ${breakpoints.sDesktop}) {
    display: flex;
    max-width: 25px;
    max-height: 20px;
    cursor: pointer;
    padding-right: 35px;
  }
`;

export const GlobalStyle = createGlobalStyle<{ isBlockedBody: boolean }>`

    ${(p) =>
      p.isBlockedBody &&
      css`
        body {
          position: fixed;
          overflow-y: scroll;
          width: 100%;
        }
      `}
`;

export const Burger = styled.img``;

export const BurgerMenu = styled.div<{ withPlank: boolean }>`
  position: absolute;
  top: 128px;
  left: 0;
  height: auto;
  width: calc(100% - 110px);
  padding-top: 20px;
  background: ${COLORS.white};
  overflow: hidden;
  margin-right: 55px;
  margin-left: 55px;

  box-shadow: 0 5px 10px rgb(0 0 0 / 10%);
  @media (max-width: ${breakpoints.mobile}) {
      margin-right: 20px;
      margin-left: 20px;
      width: calc(100% - 40px);
  }
`;

export const BurgerLinksBlock = styled.div`
    display: flex;
    flex-direction: column;
    margin-top: 20px;
    background-color: #F4F6FB;
    width: 100%;
    padding: 16px 34px;
    
    @media(max-width: 767px){
        padding: 16px;
    }
`;

export const LinkItem = styled.p`
    color: #002040;
    margin-bottom: 12px;
    font-size: 14px;
    line-height: 19px;
    
    &:last-child{
        margin-bottom: 0;
    }
`;

export const BurgerMenuWrapper = styled(GridContainer)<{ isAuth: boolean }>`
  min-width: 288px;
  position: relative;
  display: grid;
  grid-template-columns: 1fr;
  grid-template-rows: auto 1fr;
  gap: 8px;
  height: 100%;
  overflow-y: auto;

  @media (max-width: ${breakpoints.desktop}) {
    width: calc(100% - 4px);
    max-width: 1360px;
  }

  @media (max-width: ${breakpoints.mobile}) {
    display: initial;
    height: calc(100% - 32px);
    width: 100%;
  }
`;

export const BurgerCitiesWrapper = styled.div`
  display: flex;
`;

export const BurgerPayWrapper = styled.div`
    margin-top: 10px;
    max-width: 336px;
`;

export const BurgerPayButton = styled(styledButton)`
  
`;

export const BurgerCityButton = styled.div`
  background: #f4f6fb;
  border-radius: 8px;
  min-width: 160px;
  height: 35px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  &:first-child {
    margin-right: 15px;
    
    @media (max-width: 407px){
        margin-bottom: 10px;
        margin-right: 0;
    }
  }
  img {
    margin-right: 12px;
  }
  p {
    color: #F62660;
    font-size: 12px;
  }

  @media (max-width: 407px){
      width: 100%;
  }
`;
export const BurgerCitySelect = styled.div`
  color: ${COLORS.darkGrey};
  cursor: pointer;
  margin-left: auto;
  align-items: center;
  ${FONTS.Medium};

  @media (max-width: ${breakpoints.mobile}) {
    margin-left: 0;
    margin-right: auto;
  }
`;

export const MainMenuRow = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  grid-template-rows: 1fr;
  gap: 20px;

  @media (max-width: ${breakpoints.mobile}) {
    display: flex;
    margin-bottom: 40px;
  }
`;
export const ImgWrapper = styled.div`
  margin-right: 4px;
  @media (max-width: ${breakpoints.sDesktop}) {
    padding-left: 36px;
  }
`;

export const CitySelect = styled(TopMenuItem)`
  color: ${colorsConstants.darkGrey};
  cursor: pointer;
  margin-right: 90px;
  ${FONTS.Medium};
  
  &:hover{
      color: ${colorsConstants.darkGrey};
      cursor: default;
  }

  @media (max-width: ${breakpoints.tablet}) {
    margin-right: 0;
  }
`;
